import React, { type ReactNode } from 'react';
import { Error } from './';

type FormRowProps = {
  label?: ReactNode;
  error?: ReactNode;
  formField?: string;
  children?: ReactNode;
};

export function FormRow({ label, error, formField, children }: FormRowProps) {
  return (
    <div className="flex w-full py-2 leading-10" data-form-field={formField}>
      <div className="mr-4 mt-[10px] w-[200px] text-right leading-normal">
        <label className="text-[0.9rem] uppercase [&_svg]:text-[1.5rem] [&_svg]:text-[var(--primary)]">
          {label}
        </label>
      </div>
      <div className="w-full [&_input]:w-full [&_select]:w-full [&_textarea]:w-full">
        {children}
        {error ? <Error>{error}</Error> : null}
      </div>
    </div>
  );
}
